import Icon from '@material-ui/icons/ZoomIn';
import Edit from './Edit';
import List from './List';
import Show from './Show';
import Create from './Create';

export {
  Edit,
  Icon,
  List,
  Show,
  Create,
};



// WEBPACK FOOTER //
// ./src/components/Config/index.js